export interface VariableCompProps {
    title: string;
    description: string;
    output: string;
    example: string[];
}
export default function VariableComp({ title, description, output, example }: VariableCompProps) {

    return (
        <div className="mt-4">
            <h3 className="text-lg font-semibold mb-2">{title}</h3>
            <p className="">{description}</p>
            <div className="flex flex-col gap-2">
                <p className="">{output}</p>
                <p className="">Exemples : {example.map(e => <span key={e}>{e}<br/></span>)}</p>
            </div>
        </div>
    )
}